import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Routes, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/map';

import { environment } from '../../environments/environment';

const API_URL = environment.apiUrl;

@Injectable()
export class AuthenticationService {

    protected auth: any = {};
    private user = new Subject<any>();

    constructor(private http: Http, private router: Router) {
    }

    public login(username: string, password: string) {
        let body = new URLSearchParams();
        body.set('username', username);
        body.set('password', password);
        body.set('grant_type', 'password');

        return this.http
            .post(API_URL + '/oauth/token', body.toString())
            .map((response: Response) => {
                // login successful if there's a jwt token in the response
                const user_response = response.json();

                localStorage.setItem('auth_token', user_response.access_token);

                this.auth.loggedIn = true;
                this.auth.authz = user_response;
                this.loadProfile().subscribe(user => {
                    this.auth.user = user;
                    this.user.next(user);
                });

                return user_response;
            })
            .catch(this.handleError);
    }

    public change(password: string, newpassword: string, confirmPassword: string) {

        let data = { 'OldPassword': password, 'NewPassword': newpassword, 'ConfirmPassword': confirmPassword };

        return this.http
            .post(API_URL + '/Auth/ChangePassword', data)
            .map((response: Response) => {
            })
            .catch(this.handleError);
    }

    public reset(id: string, newpassword: string) {

        const data = { 'Id': id,  'NewPassword': newpassword };

        return this.http
            .post(API_URL + '/Auth/ResetPassword', data)
            .map((response: Response) => {
            })
            .catch(this.handleError);
    }

    public create(data: any) {

        return this.http
            .post(API_URL + '/Auth/Create', data)
            .map((response: Response) => {
            })
            .catch(this.handleError);
    }

    public update(data: any) {

        return this.http
            .post(API_URL + '/Auth/Update', data)
            .map((response: Response) => {
            })
            .catch(this.handleError);
    }

    loggedIn(): boolean {
        return this.auth.loggedIn;
    }

    logout() {
        this.auth.loggedIn = false;
        this.auth.authz = null;
        localStorage.removeItem('auth_token');
        this.user.next(null);
        this.router.navigate(['/login']);
    }

    public loadProfile(): Observable<any> {
        return this.http
            .get(API_URL + '/Auth/getProfile')
            .map(response => response.json())
            .catch(this.handleError);
    }

    public getById(id): Observable<any> {
        return this.http
            .get(API_URL + '/Auth/user/' + id)
            .map(response => response.json())
            .catch(this.handleError);
    }

    getToken(): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            if (this.auth.authz.token) {
                this.auth.authz
                    .updateToken(5)
                    .success(() => {
                        resolve(<string>this.auth.authz.token);
                    })
                    .error(() => {
                        reject('Failed to refresh token');
                    });
            } else {
                reject('Not loggen in');
            }
        });
    }

    hasRole(role) {
        if (this.auth.loggedIn && this.auth.user) {

            const filter = this.auth.user.roles.filter(r => r === role);
            return filter.length > 0;
        }
        return false;
    }

    getUser(): Observable<any> {
        return this.user.asObservable();
    }

    private handleError(error: Response | any) {
        console.error('AuthService::handleError', error);
        return Observable.throw(error);
    }

}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/auth/authentication.service.ts